// extracted by css-extract-rspack-plugin
export default {"cls1":"RIQuestion-cls1_bHO","cls2":"RIQuestion-cls2_hPj RIQuestion-cls1_bHO"};